import React from "react";

import { FooterStyles } from "./FooterStyles";
import { useTheme } from "../../../providers/ThemeContext";
import { useI18n } from "../../../languages/providers/I18nProvider";
import { footerData } from "./FooterContent";
import SocialLinks from "../../common/SocialLinks";

const FooterContactInfo: React.FC<{ showSocials?: boolean }> = ({
  showSocials = true,
}) => {
  const { theme } = useTheme();
  const { t } = useI18n();
  const s = FooterStyles(theme);
  const ft = theme.footerTheme;

  const toTelHref = (p: string) => `tel:${p.replace(/\s+/g, "")}`;
  const toWaHref = (p: string) =>
    `https://api.whatsapp.com/send?phone=${p.replace(/\D/g, "")}`;

  return (
    <div>
      <div style={s.colTitle}>{t("footer:columns:reach:title")}</div>

      {/* Emails */}
      {!!footerData.reach.email?.length && (
        <div style={s.contactItem}>
          <span style={s.contactStrong}>{t("footer:labels:email")}:</span>
          <br />
          {footerData.reach.email.map((e) => (
            <div key={e}>
              <a
                href={`mailto:${e}`}
                style={{ color: ft.text, textDecoration: "none" }}
              >
                {e}
              </a>
            </div>
          ))}
        </div>
      )}

      {/* Mobile */}
      {!!footerData.reach.mobile?.length && (
        <div style={s.contactItem}>
          <span style={s.contactStrong}>
            {t("footer:labels:mobile") || t("footer:labels:phone")}
          </span>
          <br />
          {footerData.reach.mobile.map((p) => (
            <div key={p}>
              <a
                href={toTelHref(p)}
                style={{ color: ft.text, textDecoration: "none" }}
              >
                {p}
              </a>
            </div>
          ))}
        </div>
      )}

      {/* Telephone */}
      {!!footerData.reach.telephone?.length && (
        <div style={s.contactItem}>
          <span style={s.contactStrong}>
            {t("footer:labels:telephone") || t("footer:labels:phone")}
          </span>
          <br />
          {footerData.reach.telephone.map((p) => (
            <div key={p}>
              <a
                href={toTelHref(p)}
                style={{ color: ft.text, textDecoration: "none" }}
              >
                {p}
              </a>
            </div>
          ))}
        </div>
      )}

      {showSocials && (
        <SocialLinks
          instagram={footerData.reach.socials.instagram}
          whatsapp={
            footerData.reach.socials.whatsapp ||
            toWaHref(footerData.reach.whatsappPhone)
          }
          color={ft.text}
          size="small"
          gap={8}
        />
      )}
    </div>
  );
};

export default FooterContactInfo;
